export const isNonZeroHighlightedValue = (
  value: unknown,
  highlightNonZero: boolean
): boolean =>
  highlightNonZero &&
  typeof value === 'number' &&
  Number.isFinite(value) &&
  value !== 0;
